module.exports = __webpack_public_path__ + "static/media/user.9042cf42.svg";